import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnavailabilityListsComponent } from './unavailability-lists.component';
import { AngularMaterialModule } from '../../angular-material/angular-material.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InlineSVGModule } from "ng-inline-svg";
import { PipesModule } from "../../pipes/index";
import { UnavailabilityFormModule } from "../../forms/unavailability-form";



@NgModule({
  declarations: [UnavailabilityListsComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule, ReactiveFormsModule,
    InlineSVGModule, PipesModule,
    UnavailabilityFormModule
  ],
  exports: [UnavailabilityListsComponent]
})
export class UnavailabilityListsModule { }
